module.exports = __webpack_public_path__ + "img/brink_slide_2.24742049.jpg";